import {proxy} from 'valtio'
import {CurrentUser} from '@/types/user'
import {ProductData} from '@/types/product'
import {SelectedTheme} from "@/types/theme";

interface AppState {
    selectedCompanyId: string | null,
    loadingPage: boolean | null | string,
    loadingPageClassNames: string | null,
    currentUser: CurrentUser | null,
    companySetting : {
        machine: null | string,
        profile_version: string,
        erp_integration: null | string,
        company_logo: null | string,
        brand_color: null | string,
    }
    status: {
        selectCompany: boolean,
        authExpired: boolean,
        lastPage: string | null,
        selectedProductInProductPage: string | null
    }
    /*products: {
        [product_id: string]: ProductData;
    }*/
    products: ProductData[],
    selectedTheme: SelectedTheme
}

const state = proxy<AppState>({
    selectedCompanyId: null,
    loadingPage: false,
    loadingPageClassNames: null,
    currentUser: null,
    companySetting : {
        machine: null,
        profile_version: 'v1',
        erp_integration: null,
        company_logo: null,
        brand_color: null,
    },

    status: {
        selectCompany: false,
        authExpired: false,
        lastPage: null,
        selectedProductInProductPage: null
    },
    products: [],
    selectedTheme: {
        id: '',
        title: '',
        originalElements: [],
        currentElements: [],
        selectedElementId: null
    }
})

export default state
